import { addToast } from "@caprikorn/dynamo-ui";
import { useMutation } from "@tanstack/react-query";

import { queryClient } from "@/AppQueryClient";
import { useGroupReferences } from "@contexts/GroupReferences/GroupReferences.context";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import { apiEcmsHttp } from "../http";
import { QUERY_KEYS } from "../keys";
import type {
  PatchUserAuthorizationsParams,
  UserWithAuthorizations,
} from "./apiEcms.types";

const patchUserAuthorizations = (
  newAuthorizations: PatchUserAuthorizationsParams,
) =>
  apiEcmsHttp.patch<UserWithAuthorizations>(
    `/users/${newAuthorizations.id}/authorizations`,
    {
      authorizations: newAuthorizations.authorizations,
    },
  );

export const usePatchUserAuthorizations = () => {
  const { currentGroup } = useGroupReferences();
  const { t } = useCustomTranslation("main");

  return useMutation({
    mutationKey: [QUERY_KEYS.USER_AUTHORIZATIONS_EDITION, currentGroup],
    mutationFn: patchUserAuthorizations,
    onSuccess: ({ data: user }) => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.USER, user.id, currentGroup],
      });
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.USERS, currentGroup],
      });
      addToast({
        variant: "success",
        title: t("userDetails.authorization.success"),
      });
    },
    onError: () => {
      addToast({
        variant: "error",
        title: t("userDetails.authorization.error"),
      });
    },
  });
};
